export default {
  club_name: { defaultValue: '' },
  is_active: { defaultValue: true }
}
